import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-view-role-exclusions',
  templateUrl: './view-role-exclusions.component.html',
  styleUrls: ['./view-role-exclusions.component.scss']
})
export class ViewRoleExclusionsComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<ViewRoleExclusionsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
